import MobileMegaMenu from './MobileMegaMenu';

export default MobileMegaMenu;
